import styled from "styled-components";

export const Article = styled.p`
  font-size: 18px;
  color: #fff;
  text-align: justify;
  width: 95%;
  margin-bottom: 10px;
`;
